<script setup lang="ts">
const props = defineProps<{
    dimension?: Dimension
}>()

/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use query params.
 */
const { config } = useParams()

/**
 * Use framework.
 */
const { isImportingRisk } = useFramework()

/**
 * Show or hide the button.
 */
const show = computed(() => {
    return isImportingRisk(props.dimension)
})
</script>

<template>
    <UiToggle
        v-if="show"
        v-model="config.importsByProduct"
        :label="t('imports-by')"
        :true-value="t('imports-by-product')"
        :false-value="t('imports-by-country')"
        class="flex-shrink-0"
        data-tutorial-step="3"
        :data-tutorial-text="t('tutorial-toggle-imports-by-product')"
    />
</template>